import React, {Component} from 'react';
import InputElement from 'react-input-mask';

class Location extends Component {

    onFieldChange(fieldName, e) {
        if (typeof this.props.handleInputChange === 'function') {
            this.props.handleInputChange(fieldName, e.target.value)
        }
    }

    render() {
        let validField = this.props.validField;
        let errorMessagePostalCode = '';
        let errorMessageFirstAddr = '';
        let errorMessageCity = '';
        let errorMessageStates = '';
        let errorMessagePhoneNumber = '';
        let errorMessageParkingDetails = '';

        for (let el in validField) {
            if (el === 'postal_code' && validField[el] === 'invalid_format') {
                errorMessagePostalCode = <em id="email-error" className="state-error">Please enter a valid postal code.</em>
            } else if (el === 'postal_code' && validField[el] === 'invalid') {
                errorMessagePostalCode =
                    <em id="email-error" className="state-error">Looks like we don't travel to your area. But contact us! We
                        try our best to accomodate any location.</em>
            } else if (el === 'postal_code' && validField[el] === 'empty') {
                errorMessagePostalCode = <em id="email-error" className="state-error">Please enter postal code.</em>
            } else if (el === 'firstaddr' && validField[el] === 'empty') {
                errorMessageFirstAddr = <em id="email-error" className="state-error">Please enter address.</em>
            } else if (el === 'firstaddr' && validField[el] === 'long') {
                errorMessageFirstAddr = <em id="email-error" className="state-error">Please enter shorter address.</em>
            } else if (el === 'city' && validField[el] === 'empty') {
                errorMessageCity = <em id="email-error" className="state-error">Please enter city.</em>
            } else if (el === 'states' && validField[el] === 'empty') {
                errorMessageStates = <em id="email-error" className="state-error">Please enter states.</em>
            } else if (el === 'phone_number' && validField[el] === 'invalid') {
                errorMessagePhoneNumber = <em id="email-error" className="state-error">Please enter valid phone number.</em>
            } else if (el === 'parking_details' && validField[el] === 'empty') {
                errorMessageParkingDetails =
                    <em id="email-error" className="state-error">Please enter parking instructions.</em>
            }
        }
        return (
            <div id="addressnew" className="hiddenbox">
                <div className="frm-row">
                    <div className="section colm colm6">
                        <label for="mobile" className='field-label'>Phone <em> * </em> </label>
                        <label
                            className={Object.keys(errorMessagePhoneNumber).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                            <InputElement
                                mask="+\19999999999"
                                maskChar=" "
                                type="tel"
                                name="mobile"
                                id="mobile"
                                className="gui-input"
                                placeholder="Tel / mobile"
                                onChange={this.onFieldChange.bind(this, 'phone_number')}
                            />
                            <span className="field-icon"><i
                                className="fa fa-phone-square"></i></span>
                        </label>
                        {
                            errorMessagePhoneNumber
                        }
                    </div>
                    <div className="section colm colm6">
                        <label for="firstaddr" className="field-label">Address <em> * </em> </label>
                        <label
                            className={Object.keys(errorMessageFirstAddr).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                            <input
                                type="text"
                                name="firstaddr"
                                id="firstaddr"
                                className="gui-input"
                                placeholder="Street address"
                                onChange={this.onFieldChange.bind(this, 'firstaddr')}
                            />
                            <span className="field-icon"><i className="fa fa-map-marker"></i></span>
                        </label>
                        {
                            errorMessageFirstAddr
                        }
                    </div>
                </div>
                <div className="frm-row">
                    <div className="section colm colm6">
                        <label for="zip" className="field-label">Zip / Postal Code <em> * </em>
                        </label>
                        <label
                            className={Object.keys(errorMessagePostalCode).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                            <input
                                type="text"
                                name="zip"
                                id="zip"
                                className="gui-input"
                                placeholder="Zip / Postal Code"
                                onChange={this.onFieldChange.bind(this, 'postal_code')}
                            />
                            <span className="field-icon"><i
                                className="fa fa-certificate"></i></span>
                        </label>
                        {
                            errorMessagePostalCode
                        }
                    </div>
                    <div className="section colm colm6">
                        <label for="city" className="field-label">City <em> * </em> </label>
                        <label for="city"
                               className={Object.keys(errorMessageCity).length > 0 ? "field select state-error" : 'field select'}>
                            <select
                                id="city"
                                name="city"
                                onChange={this.onFieldChange.bind(this, 'city')}
                            >
                                <option value="">Choose city</option>
                                {this.props.cities.map(item => (
                                    <option key={item.id} value={item.name}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <i className="arrow double"></i>
                        </label>
                        {
                            errorMessageCity
                        }
                    </div>
                </div>
                {/*<div className="frm-row">*/}
                    {/*<div className="section colm colm12">*/}
                        {/*<label for="states" className="field-label"> Province <em> * </em>*/}
                        {/*</label>*/}
                        {/*<label for="states"*/}
                               {/*className={Object.keys(errorMessageStates).length > 0 ? "field select state-error" : 'field select'}>*/}
                            {/*<select*/}
                                {/*id="states"*/}
                                {/*name="states"*/}
                                {/*onChange={this.onFieldChange.bind(this, 'states')}*/}
                            {/*>*/}
                                {/*<option value="">Choose province</option>*/}
                                {/*<option value="Ontario">Ontario</option>*/}
                            {/*</select>*/}
                            {/*<i className="arrow double"></i>*/}
                        {/*</label>*/}
                        {/*{*/}
                            {/*errorMessageStates*/}
                        {/*}*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className="section">
                    <label for="specialnotes" className="field-label">Parking Instructions <em> * </em>
                    </label>
                    <label
                        className={Object.keys(errorMessageParkingDetails).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                                            <textarea
                                                className="gui-textarea"
                                                name="specialnotes"
                                                placeholder="Where your stylist should park or any parking details, e.g, driveway, visitors parking, street parking or nearby lot."
                                                onChange={this.onFieldChange.bind(this, 'parking_details')}
                                            ></textarea>
                        <span className="field-icon"><i className="fa fa-file-text"></i></span>
                    </label>
                    {
                        errorMessageParkingDetails
                    }
                </div>
            </div>
        )
    }
}

export default Location;



/** WEBPACK FOOTER **
 ** ./src/components/Location.js
 **/